
import React from 'react';

import { Button, Menu, Dropdown, App, theme, Space  } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faClockRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { ChangeLogs } from '@features/changeLogs/components/ChangeLogs';
import { ROUTES } from '@/App/Router/routes';

/**
 * @param {tableType} Define el Tipo de tabla del que se deben retornar los headers
 */
const tableColumns = (tableType, props) => {
  const navigate = useNavigate();
  const { modal } = App.useApp();
  const { token: themeToken } = theme.useToken();

  const {
    onCrearPoliza = () => {},
    handleShowModalSendEmail = () => {},
    handleShowModalSendWhatsApp = () => {},
    onGenerateExpeditionSolicitudeishon = () => {},
    hasSolicitudesModule = false,
    onSeeQuotation = () => {},
    seeEmmitedPackage = () => {},
    whatsappLogged = false,
  } = props;

  const onAdjuntDocumentation = (numSolicitud) => {
    let url = `${process.env.URL_SOFTSEGUROS}`;
    if (url[url.length - 1] === '/') {
      url = url.substring(0, url.length - 1);
    }
    window.open(`${url}/home/#solicitudes/${numSolicitud}/documentacion/`);
  };

  const handleViewAllPlans = (quotationId) => {
    // localStorage.setItem('consulting', false);
    navigate(ROUTES.QUOTATIONS.PLANS.LIST(quotationId));
  }

  const handleShowChangeLog = (rowData) => {
    modal.confirm({
      icon: null,
      title: (
        <Space>
          <FontAwesomeIcon icon={faClockRotateLeft} color={themeToken.colorPrimary} />
          Historial de cambios
        </Space>
      ),
      content: <ChangeLogs entity='quotation' entityId={rowData.id} />,
      cancelText: 'Cerrar',
      footer: (_, { CancelBtn }) => <CancelBtn />,
      width: '60em',
    })
  }

  // const quotationId = { title: 'ID', dataIndex: 'id', key: 'id' };
  const showNumber = { title: '#', dataIndex: 'showNumber', key: 'showNumber', width: '5em', minWidth: '5em' };
  const placa = { title: 'Placa', dataIndex: 'placa', key: 'placa' };
  const vendedor = { title: 'Vendedor', dataIndex: 'vendedor', key: 'vendedor' };
  const vehicleModel = { title: 'Marca/Modelo', dataIndex: 'vehicleModel', key: 'vehicleModel' };
  const logosAseguradorasPackages = { title: 'Aseguradoras cotizadas', dataIndex: 'logosAseguradorasPackages', key: 'logosAseguradorasPackages' };
  const createdBy = { title: 'Creado por', dataIndex: 'createdBy', key: 'createdBy' };
  const createdAtFormated = { title: 'Fecha de cotización', dataIndex: 'createdAtFormated', key: 'createdAtFormated' };
  const updatedAt = { title: 'Fecha de actualización', dataIndex: 'updatedAt', key: 'updatedAt' };
  const softsegurosNumber = { title: '# Solicitud', dataIndex: 'softseguros_number', key: 'softseguros_number' };
  const solicitudExpedicionDate = { title: 'Fecha solicitud expedición', dataIndex: 'solicitud_expedicion_date_formated', key: 'solicitud_expedicion_date_formated' };
  const solicitudExpedicionPackageDetail = { title: 'Paquete expedición', dataIndex: 'solicitud_expedicion_package_detail', key: 'solicitud_expedicion_package_detail' };
  const clientDetail = { title: 'Cliente', dataIndex: 'clientDetail', key: 'clientDetail' };
  const fechaCreacionPoliza = { title: 'Fecha creación póliza', dataIndex: 'softseguros_police_created_at_detail', key: 'softseguros_police_created_at_detail' };
  const softsegurosNumeroPoliza = { title: 'Número de póliza', dataIndex: 'softseguros_police_number', key: 'softseguros_police_number' };

  const accionButton = {
    title: 'Acciones',
    key: 'action',
    render: (rowData) => (
      <Dropdown overlay={(
        <Menu>
          {tableType === 'PENDING' && (
            <Menu.Item onClick={() => navigate(ROUTES.QUOTATIONS.UPDATE(rowData.id))} key="REVIEW_AND_QUOTE">Revisar y cotizar</Menu.Item>
          )}
          {tableType === 'DONE' && (
            <Menu.Item onClick={() => onSeeQuotation(rowData.id)} key="VER_COTIZACION">Ver cotización</Menu.Item>
          )}
          {tableType === 'DONE' && <Menu.Item onClick={() => handleViewAllPlans(rowData.id)} key="VIEW_ALL_PLANS">Ver todos los planes</Menu.Item>}
          {tableType === 'DONE' && <Menu.Item onClick={() => handleShowModalSendEmail(rowData.id)} key="ENVIAR_COTIZACION">Enviar Cotización</Menu.Item>}
          {(tableType === 'DONE' && whatsappLogged) && <Menu.Item onClick={() => handleShowModalSendWhatsApp(rowData.id)} key="ENVIAR_COTIZACION_WHATSAPP">Enviar por WhatsApp</Menu.Item>}
          {(!hasSolicitudesModule && tableType === 'DONE') && (
            <Menu.Item onClick={() => onCrearPoliza(rowData)} key="CREAR_POLIZA">Crear póliza</Menu.Item>
          )}
          {(hasSolicitudesModule && tableType === 'DONE') && (
            <Menu.Item onClick={() => onGenerateExpeditionSolicitudeishon(rowData.id)} key="GENERAR_SOLICITUD_EXPEDICION">Generar solicitud de expedición</Menu.Item>
          )}

          {tableType === 'SLOPE_EMIT' && (
            <Menu.Item onClick={() => seeEmmitedPackage(rowData.id)} key="VER_EMMITTED_PACKAGE_PDF">Ver cotización individual</Menu.Item>
          )}
          {tableType === 'SLOPE_EMIT' && (
            <Menu.Item onClick={() => onAdjuntDocumentation(rowData.softseguros_number)} key="ADJUNTAR_DOCUMENTACION">Adjuntar documentación</Menu.Item>
          )}
          <Menu.Item onClick={() => handleShowChangeLog(rowData)} key='VIEW_CHANGE_LOG'>Historial de cambios</Menu.Item>
        </Menu>
      )}
      >
        <Button type="primary">
          Acciones
          <FontAwesomeIcon icon={faCaretDown} style={{ height: '20px', marginLeft: '5px' }} />
        </Button>
      </Dropdown>
    ),
  };

  let columnsReturn = [];

  if (tableType === 'PENDING') {
    columnsReturn = [
      placa, clientDetail, /*vendedor,*/ vehicleModel, createdBy, createdAtFormated, updatedAt, accionButton,
    ];
  }

  if (tableType === 'DONE') {
    columnsReturn = [
      showNumber, placa, clientDetail, /*vendedor,*/ vehicleModel, logosAseguradorasPackages, createdBy, createdAtFormated, updatedAt, accionButton,
    ];
  }

  if (tableType === 'SLOPE_EMIT') {
    columnsReturn = [
      showNumber,
      hasSolicitudesModule ? softsegurosNumber : softsegurosNumeroPoliza,
      placa,
      clientDetail,
      vendedor,
      vehicleModel,
      solicitudExpedicionPackageDetail,
      createdBy,
      createdAtFormated,
      updatedAt,
      hasSolicitudesModule ? solicitudExpedicionDate : false,
      accionButton,
    ].filter((item) => item);
  }

  if (tableType === 'EMITTED') {
    columnsReturn = [
      showNumber,
      softsegurosNumeroPoliza,
      placa,
      clientDetail,
      vendedor,
      vehicleModel,
      createdBy,
      createdAtFormated,
      updatedAt,
      hasSolicitudesModule ? solicitudExpedicionDate : false,
      fechaCreacionPoliza,
    ].filter((item) => item);
  }

  // columnsReturn.push(quotationId);
  return columnsReturn.map((item) => ({ align: 'center', ...item }));
};


export default tableColumns;
